import {
  getRequest,
  putRequest,
  postRequest,
} from "../../../system/server-call";
import { API_URLS } from "../constants";
import responseHandler from "../../../system/server-response-handler";

const { BRAND } = API_URLS;

const getAllBrandsForAiReply = (body) => {
  return postRequest(BRAND.GET_ALL_BRANDS_FOR_AI_REPLY, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateBrandSocialLinks = (body) => {
  return putRequest(BRAND.UPDATE_BRAND_SOCIAL_LINKS, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getBrandSocialLinks = (brandId) => {
  // Uncomment if real API request is needed
  return getRequest(`${BRAND.GET_BRAND_SOCIAL_LINKS}/${brandId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const aiReplyServices = {
  getBrandSocialLinks,
  getAllBrandsForAiReply,
  updateBrandSocialLinks,
};
